<template>
  <section>
    <v-row>
      <v-col class="py-0">
        <v-btn class="rotateIcon" @click="hideGoogleAuth" icon>
          <v-icon clr="var(--v-gray2-base)">$arrowBack</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-container>
      <v-row justify="center" class="mb-14">
        <div class="stepper-container">
          <Stepper :currentStep="step" />
        </div>
      </v-row>
      <div class="steps-container">
        <transition name="fade">
          <Step1 v-if="step === 1" @nextStep="nextStep" />
        </transition>

        <transition name="fade">
          <Step2 v-if="step === 2" @nextStep="nextStep" />
        </transition>

        <transition name="fade">
          <Step3 v-if="step === 3" @finish="hideGoogleAuth" />
        </transition>
      </div>
    </v-container>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import * as types from "@/store/types";
import Stepper from "@/components/AccountPage/Security/SecurityTwoFactorAuth/Stepper/index.vue";
import Step1 from "@/components/AccountPage/Security/googleAuth/Steps/Step1.vue";
import Step2 from "@/components/AccountPage/Security/googleAuth/Steps/Step2.vue";
import Step3 from "@/components/AccountPage/Security/googleAuth/Steps/Step3.vue";

export default {
  components: { Stepper, Step1, Step2, Step3 },
  data() {
    return {
      step: 1,
    };
  },
  methods: {
    ...mapActions({
      setShowGoogleAuth: types.account.actions.SET_SHOW_GOOGLE_AUTH,
    }),
    hideGoogleAuth() {
      this.setShowGoogleAuth(false);
    },
    nextStep() {
      this.step++;
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper-container {
  width: 530px;
}
.steps-container {
  max-width: 672px;
  margin: 0 auto;
}

// .fade-enter-active,
// .fade-leave-active {
//   transition: opacity 0.5s ease-out;
// }
// .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
//   opacity: 0;
// }

// .transition {
//   transition: 1s cubic-bezier(0, 0.55, 0.45, 1);
// }
</style>
